export enum AppEnvironmentEnum {
  Localhost = "Localhost",
  Develop = "Develop",
  Test = "Test",
  Production = "Production",
}

export function getAppEnvironmentShort() {
  if (window.location.href.includes("localhost")) return "local";
  if (window.location.href.includes("sive-deve")) return "dev";
  if (window.location.href.includes("sive-test")) return "test";
  return "prod";
}
